import styled from 'styled-components'

export const DataLoading = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
`
